import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateSample, type UpdateSampleParams } from '../services/sampleUpdateService';
import { useAuth } from '@/features/auth/';

export const useSampleUpdate = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ sampleId, params }: { sampleId: string; params: UpdateSampleParams }) => {
      if (!user?.id) {
        throw new Error('Usuario no autenticado');
      }

      const updateParams: UpdateSampleParams = {
        ...params,
        createdByUserId: user.id
      };

      return updateSample(sampleId, updateParams);
    },
    onSuccess: () => {
      // Invalidar la caché de muestras para forzar una nueva búsqueda
      queryClient.invalidateQueries({ queryKey: ['samples'] });
    }
  });

  return {
    updateSample: mutation.mutate,
    updateSampleAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error,
    isError: mutation.isError
  };
}; 